import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { spacing } from '../../../design-system/tokens';
import { Input } from '../../../design-system/components/inputs/Input';

interface ProjectSetupProps {
  data: { name: string } | null;
  onDataChange: (data: { name: string }) => void;
  organizationName?: string;
}

const Container = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

const Title = styled.h2`
  font-size: 32px;
  font-weight: 600;
  color: #222429;
  margin: 0 0 12px 0;
  line-height: 1.25;
  letter-spacing: -0.025em;
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #64748b;
  margin: 0 0 ${spacing[10]} 0;
  line-height: 1.5;
  font-weight: 400;
`;

const FormGroup = styled.div`
  margin-bottom: ${spacing[8]};
`;

const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  margin-bottom: 12px;
`;

export const ProjectSetup: React.FC<ProjectSetupProps> = ({ 
  data, 
  onDataChange, 
  organizationName 
}) => {
  const [projectName, setProjectName] = useState(data?.name || '');

  // Set default project name when organizationName is available
  useEffect(() => {
    if (organizationName && !projectName) {
      const defaultName = `${organizationName} Campaign`;
      setProjectName(defaultName);
      onDataChange({
        name: defaultName
      });
    }
  }, [organizationName, projectName, onDataChange]);

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setProjectName(value);
    onDataChange({
      name: value
    });
  };

  return (
    <Container>
      <Title>Set up your first project</Title>
      <Subtitle>
        Create your first project to start managing creator campaigns and outreach.
      </Subtitle>

      <FormGroup>
        <Label htmlFor="project-name">Project name</Label>
        <Input
          id="project-name"
          type="text"
          value={projectName}
          onChange={handleNameChange}
          placeholder="e.g., Summer Campaign 2024"
          required
        />
      </FormGroup>
    </Container>
  );
};
